import styled from 'styled-components'

import { style } from 'theme'

export const Content = styled.div`
  max-width: 340px;
  margin: 40px auto 80px;
`

export const Dropdowns = styled.div`
  display: grid;
  grid-template-rows: 1fr;
  gap: 20px;
`

export const HeroHeader = styled.h2`
  font-size: 22px;
  line-height: 30px;
  margin: 30px auto 10px;
  text-align: center;
  font-weight: bold;

  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    margin: 0px auto 10px;
  }
`

export const HeroText = styled.p`
  font-size: 14px;
  line-height: 22px;
  margin: 0 auto 40px;
  text-align: center;
  max-width: 520px;
`
